export const MONGODB_OBJECT_ID = new RegExp('[0-9a-f]{24}');
